import { render, staticRenderFns } from "./SpinGift.vue?vue&type=template&id=19a21e01"
import script from "./SpinGift.vue?vue&type=script&lang=js"
export * from "./SpinGift.vue?vue&type=script&lang=js"
import style0 from "./SpinGift.vue?vue&type=style&index=0&id=19a21e01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports